<div class="step-container">
  <h2 class="step-title">Domicilio</h2>
  <p class="step-subtitle">Ingrese su dirección actual. Comience a escribir y seleccione de las sugerencias.</p>

  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="step-form">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Dirección</mat-label>
      <input
        #addressInput
        matInput
        formControlName="address"
        type="text"
        placeholder="Ej: Av. Corrientes 1234, CABA"
        autocomplete="street-address" />
      <mat-icon matPrefix>location_on</mat-icon>
      <mat-error *ngIf="form.get('address')?.hasError('required')">
        La dirección es obligatoria.
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Piso / Departamento (opcional)</mat-label>
      <input
        matInput
        formControlName="unit"
        type="text"
        placeholder="Ej: 3ro B" />
      <mat-icon matPrefix>apartment</mat-icon>
    </mat-form-field>

    <div *ngIf="errorMessage" class="error-message">
      <mat-icon>error_outline</mat-icon>
      <span>{{ errorMessage }}</span>
    </div>

    <button
      mat-raised-button
      color="primary"
      class="action-button"
      type="submit"
      [disabled]="loading">
      <mat-spinner *ngIf="loading" diameter="24" class="button-spinner"></mat-spinner>
      <span *ngIf="!loading">Guardar dirección</span>
    </button>
  </form>
</div>
